import React from "react";
import { CommonButton } from "../../Input";

const Step5Success = ({ onClose }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "60vh" }}
    >
      <div
        className="text-center  p-5 rounded-4  position-relative"
        style={{ maxWidth: "800px", width: "100%" }}
      >
        <div className="mb-4 mt-2">
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0ZM32 60L12 40L17.656 34.344L32 48.688L62.344 18.344L68 24L32 60Z"
              fill="#10B981"
            />
          </svg>
        </div>
        <h2 className="fw-bold text-success mb-3 fs-32">
          Transaction Created Successfully!
        </h2>
        <p className="text-muted fs-15 px-lg-5 mx-lg-4">
          The transaction has been created and is waiting for the admin's
          approval. You can now download, print, or email the receipt.
        </p>
        <div className="mt-2 text-center pt-2">
          <CommonButton onClick={onClose}>Close</CommonButton>
        </div>
      </div>
    </div>
  );
};

export default Step5Success;
